import widgetConfig from './index';

let centerCls = {
        "justify-content": "center",
        "text-align":"center"
    }
let skillStrengthsAndWeaknessesConfig = {
    title: 'Skills strengths and weaknesses',
    skillTypes: {
      objectives: 'objective',
      skills: 'question'
    },
    skillLables: {
      objectives: 'Assessment objectives',
      skills: 'Skills'
    },
    filterLables: {
      objectives: 'assessment objectives',
      skills: 'skills'
    },
    tableColumnDefinition: [
      {
        headerName: "Skill",
        field: "description",
        sortable: true,
        minWidth: 300,
        unSortIcon: true,
        sortingOrder: ['asc'],
        headerTooltip: 'Skill'
      }
      , {
        headerName: "Group average %",
        field: "groupAverage",
        sortable: true,
        minWidth: 200,
        unSortIcon: true,
        sortingOrder: ['asc'],
        headerTooltip: 'Group average',
         cellStyle: centerCls
      }
      , {
        headerName: "Number of questions",
        field: "numberOfQuestion",
        sortable: true,
        minWidth: 240,
        unSortIcon: true,
        sortingOrder: ['asc'],
        headerTooltip: 'Number of questions',
         cellStyle: centerCls
      }
    ],
    tableIcons: {
        sortAscending: '<i className=""></i>', //ag-icon ag-icon-asc
        sortDescending: '<i className=""></i>',     //ag-icon ag-icon-desc          
    },
    chartConfig: {
      "type": 'bar2d',
      "renderAt": 'chart-container',
      "width": '96%',
      "height": '100%',

      "dataFormat": 'json',
      "dataSource": {
        "chart": {
          "theme": "fusion",
          "rotateXAxisName": "0",
          "xAxisname": "Skills <br />tested",
          "yAxisName": "Group average (%)",
          "alignCaptionWithCanvas": "0",
          "showPlotBorder": "1",
          "plotBorderThickness": "2",
          "showToolTip": "0",
          "showValues": "1",
          "plotSpacePercent": "48",
          "plotBorderColor": widgetConfig.colorCodes.borderColor
        },
        "data": []
      }
    },

 badChartConfig :  {
      "label": "",//bad
      "value": "",
      "displayValue": "",
      "color": widgetConfig.colorCodes.badHover,
      "borderHoverColor": widgetConfig.colorCodes.bad,
      "hoverColor": widgetConfig.colorCodes.bad
    },
   avgChartConfig : {
      "label": "",
      "value": "",
      "displayValue": "",
      "color": widgetConfig.colorCodes.avgHover,
      "dashed": "1",
      "inheritPlotBorderColor": "1",
      //"plotBorderColor": widgetConfig.colorCodes.avg,
      // "borderColor": widgetConfig.colorCodes.avg
      "dashLen": "3",
      "borderHoverColor": widgetConfig.colorCodes.avg,
      "hoverColor": widgetConfig.colorCodes.avg,
      "borderHoverDashed": "0"

    },
    goodChartConfig : {
      "label": "",
      "value": "",
      "displayValue": "",
      "color": widgetConfig.colorCodes.goodHover,
      "showPlotBorder": "0",
      "dashed": "1",
      "plotBorderThickness": "0",
      "dashLen": "8",
      "borderHoverColor": widgetConfig.colorCodes.good,
      "hoverColor": widgetConfig.colorCodes.good,
      "borderHoverDashed": "0"

    }
}

export default skillStrengthsAndWeaknessesConfig;
